/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface OrganizationsCreateBillingPortalSession$Params {

/**
 * The ID of the organization
 */
  organizationId: string;
}

export function organizationsCreateBillingPortalSession(http: HttpClient, rootUrl: string, params: OrganizationsCreateBillingPortalSession$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Stripe Billing Portal URL.
 */
'url': string;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsCreateBillingPortalSession.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * Stripe Billing Portal URL.
       */
      'url': string;
      }>;
    })
  );
}

organizationsCreateBillingPortalSession.PATH = '/organizations/{organizationId}/subscription/billing-portal-session';
